var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { IntlProvider, addLocaleData } from "react-intl";
import en from "react-intl/locale-data/en";
import fr from "react-intl/locale-data/fr";
import { connect } from "@irati/store";
import authentication from "@irati/auth";
import getKey from "./helpers/getKey";
import getSupportedLocale from "./helpers/getSupportedLocale";
addLocaleData(__spreadArrays(en, fr));
var LangProvider = /** @class */ (function (_super) {
    __extends(LangProvider, _super);
    function LangProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LangProvider.prototype.render = function () {
        var lang = this.props.lang;
        var messages = lang.messages || {};
        var locale = getSupportedLocale(authentication.userLocale());
        return React.createElement(IntlProvider, __assign({}, this.props, { locale: locale, key: getKey({ locale: locale, messages: messages }), messages: messages }));
    };
    LangProvider.propTypes = {
        lang: PropTypes.object.isRequired,
        auth: PropTypes.object.isRequired
    };
    return LangProvider;
}(PureComponent));
/** @desc: need auth to make sure this re-renders on any auth changes although not directly used */
var mapStateToProps = function (_a) {
    var lang = _a.lang, auth = _a.auth;
    return ({ lang: lang, auth: auth });
};
export default connect(mapStateToProps)(LangProvider);
